export default __webpack_public_path__ + "static/media/cholet10.debef990.jpg";